import React from 'react';
import styled from 'styled-components';
import { breakpoints } from '@/components/responsive';

export function HeroVideo() {
  return (
    <Wrapper className="hero-video-wrapper">
      <iframe
        title="visually-io-video"
        src="https://iframe.mediadelivery.net/embed/162751/e15b1776-d4f0-40af-8d13-8424070561c3?autoplay=true&loop=true&muted=true&preload=true"
        loading="lazy"
        allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
        allowFullScreen
      />
    </Wrapper>
  );
}

const Wrapper = styled.div`
  margin-top: 3rem;
  margin-bottom: 10rem !important;
  position: relative;

  pointer-events: none;

  ${breakpoints.down(`md`)} {
    pointer-events: auto;
  }

  display: flex;
  justify-content: center;
  align-items: center;

  padding-bottom: 56%;
  width: 90vw;
  box-shadow: 5px 5px 24px 5px rgba(191, 167, 183, 0.58);
  border-radius: 3rem;
  background: transparent;

  ${breakpoints.down(`md`)} {
    border-radius: 1rem;
    margin-bottom: 5rem !important;
  }

  iframe {
    background: transparent;
    border-radius: 3rem;
    overflow: hidden;
    appearance: none;
    border: none;
    height: 101%;
    width: 100%;
    position: absolute;
    inset: 0 0 0 0;

    ${breakpoints.down(`md`)} {
      border-radius: 1rem;
    }
  }
`;
